import React from 'react';
import { withRouter } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { Container, Grid, Column, SignupForm, Section } from 'components';
import * as help from 'helpers';
import { sendSignupPageView } from 'tracking/sendTrackingEvent';

const Page = (history) => {
    const destination = help.route_continue_with_params();

    help.useEffectOnlyOnce(() => {
        sendSignupPageView();
    });

    return (
        <React.Fragment>
            <Section topMargin minHeight="100vh" overlay="light">
                <Container>
                    <Grid alignCenter>
                        <Column cols={6} tablet={8} desktop={5}>
                            <SignupForm
                                onSignupDestination={destination || '/'}
                                history={history}
                            />
                        </Column>
                    </Grid>
                </Container>
            </Section>
        </React.Fragment>
    );
};

export default withRouter(observer(Page));
